import * as React from 'react';
import { Table, TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col, Label, Input } from 'reactstrap';
import { useState, useEffect } from 'react';
import Page from '../Page';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { FactTable, Afr, getSelectedAfr, updateVersionStateValue, generateLocalStateFromEventProperties, versionStateValue, updateTableFact, existFactsInTable, getTable } from '../../redux/AfrSlice';
import RevenuesCoreDetail from '../AfrCore/RevenuesCoreDetail';
import RevenuesCoreImpactFees from '../AfrCore/RevenuesCoreImpactFees';
import { setIsDirty, isAdmin, getTaxonomyType, getSectionDimensionMap } from '../../redux/MiscSlice';
import { Concept, resetConceptState } from "../../redux/ConceptSlice";
import utilityHelper from '../../utils/utilityHelper';
import { useLocation } from 'react-router-dom';
import enums from '../../utils/enums';
import { getNetworkFilterIds, getNetworkFilters } from './CourtReporting939DataCore';
import { LogicalPeriodEnum } from '../../redux/TaxonomyVersionSlice';

const getReviewKey = function (dataSection: string) {
    return "reviewState_cr939" + dataSection + "Reviewed";
}
const DataSummary939 = (props: { userRole: string, dataSection: string }) => {

    const sectDimMap: any = useAppSelector(getSectionDimensionMap);
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const ename = entity ? entity.name : "";
    const ecode = entity ? entity.code : "";
    const [state, setState] = useState(generateLocalStateFromEventProperties(currentAfr, ["workState_" + props.dataSection, getReviewKey(props.dataSection)]));
    const [activeTab, setActiveTab] = useState("1");
    const [hasFacts, setHasFacts] = useState(true);
    const [bsDocumentation, setBsDocumentation] = useState<string[]>([]);
    const [balanceCIForward, setBalanceCIForward] = useState<number>(0);
    const [balanceQ4CIForward, setBalanceQ4CIForward] = useState<number>(0);
    const [balanceLAPForward, setBalanceLAPForward] = useState<number>(0);
    const [balanceLLForward, setBalanceLLForward] = useState<number>(0);
    const [balanceJAPForward, setBalanceJAPForward] = useState<number>(0);
    const [balanceForward, setBalanceForward] = useState<number>(0);
    const [revenueMap, setRevenueMap] = useState<any>({});
    const [expenditureMap, setExpenditureMap] = useState<any>({});


    const isAdminUser: boolean = useAppSelector(isAdmin);
    /* ************************************** Redux ********************************************/
    const dispatch = useAppDispatch();

    const toggle = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            utilityHelper.saveDeferredChanges(dispatch);
        }
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }


    const currVersion = function () {
        if (currentAfr) {
            if (currentAfr.currentversion) {
                if (currentAfr.currentversion.versionState) {
                    return currentAfr.currentversion.versionState;
                }
            }
        }
        return null;
    }

    // Cell Handler
    const handleCellEdited = function (cell: any) {
        var row = cell.getRow();
        var rowid = row.getData().accountCode;
        var conceptId = row.getData().accountId;
        var fieldid = cell.getField();
        var newvalue = cell.getValue();
        dispatch(updateTableFact(
            {
                tableId: "uas_006_balance-sheet",
                rowId: rowid,
                fundGroup: fieldid,
                concept: conceptId,
                value: newvalue
            }));

    }

    const handleChangeCheckbox = function (event: any) {

        var checkValues = JSON.parse(JSON.stringify(state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked

        setState(checkValues);

        // here call to dispatcher sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

    }


    useEffect(() => {
        if (!currentAfr) return;
        if (!currentAfr.currentversion) return;
        // get state from redux
        var newLocalState = generateLocalStateFromEventProperties(currentAfr, ["workState_" + props.dataSection, getReviewKey(props.dataSection)])

        // enable/disable checkbox when there are (no) facts 
        setHasFacts(existFactsInTable(currentAfr, ["939-court-reporting-revenues","939-court-reporting-expenditures"]))

        // create a local state from redux
        setState(newLocalState)

    }, [currentAfr, currVersion()])

    const getBalanceForward = function (datasection: string): number {
        var total = 0;
        if (currentAfr) {
            total = utilityHelper.getTableRevenuesMinusExpenditures(
                getTable(currentAfr, "939-court-reporting-revenues"),
                getTable(currentAfr, "939-court-reporting-expenditures"),
                (datasection === "Summary") ? [] : getNetworkFilterIds(sectDimMap, datasection)
            );
        }
        return total;
    }
    const getFormattedFactValue = function(fMap: any, key: string) : string {
        if (!fMap.hasOwnProperty(key)) {
            return utilityHelper.FormatterWithDecimals("0", "XBRLI_MONETARYITEMTYPE", 0);
        }
        return utilityHelper.FormatterWithDecimals(fMap[key] + "", "XBRLI_MONETARYITEMTYPE",0);
    }
    const headerStyle = {
        backgroundColor: "#203764",
        color:"white"
    }
    // NOTE - The fix of putting 'as const' after the textAlign value avoids complaints about the string not matching a typescript enumeration
    // solution courtesy of https://stackoverflow.com/questions/58551655/cssproperties-textalignproperty-type-error
    const valueStyle = {
        textAlign: 'right' as const,
        paddingRight: "2em",
        marginBottom: "0em"
    }
    useEffect(() => {
        setBalanceCIForward(getBalanceForward("CourtInnovations"));
        setBalanceLAPForward(getBalanceForward("LegalAidProgram"));
        setBalanceLLForward(getBalanceForward("LawLibrary"));
        setBalanceJAPForward(getBalanceForward("JuvenileAlternativeProgram"));
        setBalanceForward(getBalanceForward("Summary"));
        setBalanceQ4CIForward(
            Math.max(getBalanceForward("CourtInnovations"), 0)
            + Math.max(getBalanceForward("LegalAidProgram"), 0)
            + Math.max(getBalanceForward("LawLibrary"), 0)
            + Math.max(getBalanceForward("JuvenileAlternativeProgram"), 0)
        );
        var revMap: any = {};
        var expMap: any = {};
        if (currentAfr ) {
            var dsections = ["CourtInnovations", "LegalAidProgram", "LawLibrary", "JuvenileAlternativeProgram"];
            var tbRev: FactTable | null = getTable(currentAfr, "939-court-reporting-revenues");
            revMap = utilityHelper.getFactValueMap(tbRev);
            var revTotal = utilityHelper.getFilteredTableTotal(tbRev, null, null);
            revMap["TableTotal"] = revTotal;
            var tbExp : FactTable | null = getTable(currentAfr, "939-court-reporting-expenditures");
            ["CR_939_CarryForward", "CR_939_RevenuesReceived","CR_939_InterestIncome"].map((concept, idx) => {
                var cfilter: any = {};
                cfilter[concept] = true;
                var rowTotal = utilityHelper.getFilteredTableTotal(tbRev, cfilter, null);
                revMap[concept] = rowTotal;
            });
            dsections.map((datasection: string, idx) => {
                var dfilter: any = {};
                dfilter["CR_939_" + datasection] = true;
                var colSubTotal = utilityHelper.getFilteredTableTotal(tbRev, null, dfilter);
                var dkey = "939 Axis#CR_939_" + datasection;
                if (expMap.hasOwnProperty(dkey)) {
                    colSubTotal += expMap[dkey];
                }
                revMap[dkey] = colSubTotal;
            });
            ["CR_939_Personnel", "CR_939_Operating", "CR_939_Capital", "CR_939_Unspecified"].map((concept, idx) => {
                var cfilter: any = {};
                cfilter[concept] = true;
                var rowTotal = utilityHelper.getFilteredTableTotal(tbExp, cfilter, null);
                expMap[concept] = rowTotal;

                dsections.map((datasection: string, idx) => {
                    var dfilter: any = {};
                    getNetworkFilters(sectDimMap, datasection).map((program: Concept, idx) => {
                        dfilter[program.id] = true;
                    })
                    var subTotal = utilityHelper.getFilteredTableTotal(tbExp, cfilter, dfilter);
                    var dkey = "939 Axis#CR_939_" + datasection;
                    var fkey = concept + "|" + dkey;
                    expMap[fkey] = subTotal;
                })
            })
            dsections.map((datasection: string) => {
                var dfilter: any = {};
                getNetworkFilters(sectDimMap, datasection).map((program: Concept, idx) => {
                    dfilter[program.id] = true;
                })
                var colSubTotal = utilityHelper.getFilteredTableTotal(tbExp, null, dfilter);
                var dkey = "939 Axis#CR_939_" + datasection;
                if (expMap.hasOwnProperty(dkey)) {
                    colSubTotal += expMap[dkey];
                }
                expMap[dkey] = colSubTotal;
            });
            var expTotal = utilityHelper.getFilteredTableTotal(tbExp, null, null);
            expMap["TableTotal"] = expTotal;
        }
        setRevenueMap(revMap);
        setExpenditureMap(expMap);
    }, [])
    return (
        <React.Fragment>
            <Page>
                <h2>{props.dataSection} for {ename} ({ecode}), {utilityHelper.getAfrYearDescriptor(currentAfr)}</h2>
                {isAdminUser && (
                    <Row>
                        <Col>
                            <div className="box-events pl-2 pr-3 py-3 my-2">
                                <div>
                                    <Label className="ml-5" check>
                                        <Input type="checkbox"
                                            name={getReviewKey(props.dataSection)}
                                            onChange={handleChangeCheckbox}
                                            disabled={!utilityHelper.checkStatusList(currentAfr, enums.certifiedRecertified)}
                                            checked={state[getReviewKey(props.dataSection)] ? true : false}
                                        /><b>Reviewed</b>
                                    </Label>
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col>
                        <Table>
                            <colgroup>
                                <col style={{ width: "20%" }}></col>
                                <col style={{ width: "15%" }}></col>
                                <col style={{ width: "15%" }}></col>
                                <col style={{ width: "15%" }}></col>
                                <col style={{ width: "20%" }}></col>
                                <col style={{ width: "15%" }}></col>
                            </colgroup>
                            <thead>
                                <th style={headerStyle}>Type of Revenue</th>
                                <th style={headerStyle}>Court Innovations</th>
                                <th style={headerStyle}>Legal Aid Program</th>
                                <th style={headerStyle}>Law Library</th>
                                <th style={headerStyle}>Juvenile Alternative Program</th>
                                <th style={headerStyle}>Total</th>
                            </thead>
                            <tbody>
                                {["Carry Forward", "Revenues Received", "Interest Income"].map((concept, idx) => (
                                    <tr>
                                        <td>{concept}</td>
                                        {
                                            ["CourtInnovations", "LegalAidProgram", "LawLibrary", "JuvenileAlternativeProgram"].map((program: string, idx) => (
                                                <td><p style={valueStyle}>{getFormattedFactValue(revenueMap, "CR_939_" + concept.replace(" ", "") + "|939 Axis#CR_939_" + program)}</p></td>
                                            ))
                                        }
                                        <td><p style={valueStyle}>{getFormattedFactValue(revenueMap, "CR_939_" + concept.replace(" ", ""))}</p></td>
                                    </tr>
                                ))}
                                <tr>
                                    <td>Total</td>
                                    {
                                        ["CourtInnovations", "LegalAidProgram", "LawLibrary", "JuvenileAlternativeProgram"].map((program: string, idx) => (
                                            <td><p style={valueStyle}>{getFormattedFactValue(revenueMap, "939 Axis#CR_939_" + program)}</p></td>
                                        ))
                                    }
                                    <td><p style={valueStyle}>{getFormattedFactValue(revenueMap, "TableTotal")}</p></td>
                                </tr>
                            </tbody>
                        </Table>
                        <Table>
                            <colgroup>
                                <col style={{ width: "20%" }}></col>
                                <col style={{ width: "15%" }}></col>
                                <col style={{ width: "15%" }}></col>
                                <col style={{ width: "15%" }}></col>
                                <col style={{ width: "20%" }}></col>
                                <col style={{ width: "15%" }}></col>
                            </colgroup>
                            <thead>
                                <th style={headerStyle}>Type of Expenditure</th>
                                <th style={headerStyle}>Court Innovations</th>
                                <th style={headerStyle}>Legal Aid Program</th>
                                <th style={headerStyle}>Law Library</th>
                                <th style={headerStyle}>Juvenile Alternative Program</th>
                                <th style={headerStyle}>Total</th>
                            </thead>
                            <tbody>
                                {["Personnel", "Operating", "Capital","Unspecified"].map((concept, idx) => (
                                    <tr>
                                        <td>{concept}</td>
                                        {
                                            ["CourtInnovations", "LegalAidProgram", "LawLibrary", "JuvenileAlternativeProgram"].map((program: string, idx) => (
                                                <td><p style={valueStyle}>{getFormattedFactValue(expenditureMap, "CR_939_" + concept.replace(" ", "") + "|939 Axis#CR_939_" + program)}</p></td>
                                            ))
                                        }
                                                    <td><p style={valueStyle}>{getFormattedFactValue(expenditureMap, "CR_939_" + concept.replace(" ", ""))}</p></td>
                                    </tr>
                                ))}
                                <tr>
                                    <td>Total</td>
                                    {
                                        ["CourtInnovations", "LegalAidProgram", "LawLibrary", "JuvenileAlternativeProgram"].map((program: string, idx) => (
                                            <td><p style={valueStyle}>{getFormattedFactValue(expenditureMap, "939 Axis#CR_939_" + program)}</p></td>
                                        ))
                                    }
                                    <td><p style={valueStyle}>{getFormattedFactValue(expenditureMap, "TableTotal")}</p></td>
                                </tr>
                            </tbody>
                        </Table>
                        <Table>
                            <colgroup>
                                <col style={{width:"20%"}}></col>
                                <col style={{ width: "15%" }}></col>
                                <col style={{ width: "15%" }}></col>
                                <col style={{ width: "15%" }}></col>
                                <col style={{ width: "20%" }}></col>
                                <col style={{ width: "15%" }}></col>
                            </colgroup>
                            <thead>
                                <th style={headerStyle}>Carry Forward Balance</th>
                                <th style={headerStyle}>Court Innovations</th>
                                <th style={headerStyle}>Legal Aid Program</th>
                                <th style={headerStyle}>Law Library</th>
                                <th style={headerStyle}>Juvenile Alternative Program</th>
                                <th style={headerStyle}>Total</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Balance/Deficit per Program</td>
                                    <td><p style={valueStyle}>{utilityHelper.FormatterWithDecimals(balanceCIForward + "", "XBRLI_MONETARYITEMTYPE",0)}</p></td>
                                    <td><p style={valueStyle}>{utilityHelper.FormatterWithDecimals(balanceLAPForward + "", "XBRLI_MONETARYITEMTYPE",0)}</p></td>
                                    <td><p style={valueStyle}>{utilityHelper.FormatterWithDecimals(balanceLLForward + "", "XBRLI_MONETARYITEMTYPE",0)}</p></td>
                                    <td><p style={valueStyle}>{utilityHelper.FormatterWithDecimals(balanceJAPForward + "", "XBRLI_MONETARYITEMTYPE",0)}</p></td>
                                    <td><p style={valueStyle}>{utilityHelper.FormatterWithDecimals(balanceForward + "", "XBRLI_MONETARYITEMTYPE",0)}</p></td>
                                </tr>
                                {currentAfr && currentAfr.logicalPeriod && currentAfr.logicalPeriod === LogicalPeriodEnum.Q_4
                                    ?
                                    <tr>
                                        <td>Carry-Forward Balance for Q1 Reporting</td>
                                        <td><p style={valueStyle}>{utilityHelper.FormatterWithDecimals(balanceQ4CIForward + "", "XBRLI_MONETARYITEMTYPE", 0)}</p></td>
                                        <td><p style={valueStyle}>{utilityHelper.FormatterWithDecimals("0", "XBRLI_MONETARYITEMTYPE", 0)}</p></td>
                                        <td><p style={valueStyle}>{utilityHelper.FormatterWithDecimals("0", "XBRLI_MONETARYITEMTYPE", 0)}</p></td>
                                        <td><p style={valueStyle}>{utilityHelper.FormatterWithDecimals("0", "XBRLI_MONETARYITEMTYPE", 0)}</p></td>
                                        <td><p style={valueStyle}>{utilityHelper.FormatterWithDecimals(balanceQ4CIForward + "", "XBRLI_MONETARYITEMTYPE", 0)}</p></td>
                                    </tr>
                                    : <tr></tr>

                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default DataSummary939;